"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const react_syntax_highlighter_1 = require("react-syntax-highlighter");
exports.Container = styled_components_1.default(react_syntax_highlighter_1.Prism) `
  & span {
    font-family: monospace !important;
    font-size: 10pt !important;
  }
`;
